// Enums para evitar strings mágicas
export enum BillingType {
  SESSIONS = 'sessions',
  HOURS = 'hours'
}

export enum UserType {
  PATIENT = 'patient',
  THERAPIST = 'therapist'
}

export enum UserRole {
  PATIENT = 'paciente',
  THERAPIST = 'terapeuta',
  PARTICIPANT = 'participante',
  LOGIN_NOT_COMPLETED = 'login-not-completed',
  ADMIN = 'administrador'
}

// Interface do plano
export interface Plan {
  id?: string;
  name: string;
  value: number;
  billingType: BillingType;
  quantity: number;
  userType: UserType;
  isRecurring: boolean;
  description: string;
  isFeatured?: boolean;
  sessionLabel?: string; // Nova label configurável para planos de sessão
  features?: string[]; // Tópicos destacando diferenciais do plano
  deleted?: boolean; // Soft-delete flag
  therapistCommission?: number; // Percentual que vai para o terapeuta (apenas para constelações de pacientes)
  platformFee?: number; // Percentual que fica na plataforma (apenas para constelações de pacientes)
  // Compra personalizada de horas (apenas planos billingType=HOURS, isRecurring=false)
  allowCustomQuantity?: boolean;
  minQuantity?: number;
  maxQuantity?: number;
  /** MONTHLY = mensalidade; YEARLY = valor do compromisso de 12 meses */
  cycle?: "MONTHLY" | "YEARLY";
  allowPixInstallments?: boolean;
  maxPixInstallments?: number;
  /** false = plano homologado / fidelidade — não pode cancelar */
  cancellable?: boolean;
  homologationMonths?: number;
  /** Homologação sem crédito de horas */
  homologationOnly?: boolean;
}

// Status de assinatura
export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  SUSPENDED = 'SUSPENDED'
}

// Interface para assinatura ativa
export interface ActiveSubscription {
  id: string;
  userId: string;
  planId: string;
  planName: string;
  asaasSubscriptionId: string;
  status: SubscriptionStatus;
  value: number;
  cycle: string;
  billingType: BillingType;
  userType: UserType;
  sessionLabel?: string; // Identifica se é constelação, participação, etc
  createdAt: any;
  nextDueDate: any;
  canceledAt?: any;
  expiresAt?: any;
  cancellable?: boolean;
  homologationMonths?: number;
  asaasInstallmentId?: string;
  paymentMethod?: string;
}
